export default __webpack_public_path__ + "static/media/github.0a1ec797.svg";